import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, createCommentVNode as _createCommentVNode } from "vue"

import { ref, computed } from 'vue';

interface Props {
  data: { [key: string]: string }[];
  label: string;
  labelWidth?: number;
  labelAlign?: 'right' | 'center' | 'left';
  labelPosition?: 'left' | 'top';
  labelColor?: string;
  scrollHeight?: string | number;
  required?: boolean;
  border?: boolean;
  field?: { id: string; name: string };
  isMinCheckRequired?: boolean;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  props: /*@__PURE__*/_mergeModels({
    data: { default: () => [] },
    label: { default: '标题' },
    labelWidth: { default: 120 },
    labelAlign: { default: 'center' },
    labelPosition: { default: 'left' },
    labelColor: { default: '#000' },
    scrollHeight: { default: 40 },
    required: { type: Boolean, default: true },
    border: { type: Boolean, default: true },
    field: { default: () => ({ id: 'id', name: 'name' }) },
    isMinCheckRequired: { type: Boolean, default: true }
  }, {
    "value": { default: () => [] },
    "valueModifiers": {},
  }),
  emits: /*@__PURE__*/_mergeModels(["change"], ["update:value"]),
  setup(__props: any, { emit: __emit }) {

const value = _useModel<string[]>(__props, 'value');
const props = __props;
const emits = __emit;

const themeVars = ref({
  checkboxLabelColor: '#000',
  primaryColor: '#165dff',
});
const isClick = ref(false);
let lastCancelledValue = ref<string | null>(null); // 记录最后取消选择的值

// 设置 label 宽度
const setLabelWidth = computed(() =>
  props.labelPosition === 'left' ? `${props.labelWidth}px` : '100%'
);

// 设置 label 对齐方式
const setLabelAlign = computed(() =>
  props.labelPosition === 'left' ? `text-${props.labelAlign}` : 'text-left'
);

// 设置 scroll-view 高度
const setScrollHeight = computed(() =>
  props.labelPosition === 'left' ? `${props.scrollHeight}px` : 'auto'
);
// 设置 label高度
const setLabelHeight = computed(() =>
  props.labelPosition === 'top' ? `${props.scrollHeight}px` : 'auto'
);

// 处理选项点击
const handleClick = (id: string) => {
  if (value.value?.length <= 1) {
    lastCancelledValue.value = id;
  }
};

// 处理选项改变
const handleChange = (selectedValues: string[]) => {
  const selectedItems = selectedValues.map(id =>
    props.data.find(item => item[props.field.id] === id)
  );
  emits('change', { selectedValues, selectedItems, isClick: isClick.value });
};

return (_ctx: any,_cache: any) => {
  const _component_nut_checkbox = _resolveComponent("nut-checkbox")!
  const _component_nut_checkbox_group = _resolveComponent("nut-checkbox-group")!
  const _component_nut_config_provider = _resolveComponent("nut-config-provider")!
  const _component_nut_skeleton = _resolveComponent("nut-skeleton")!
  const _component_taro_scroll_view = _resolveComponent("taro-scroll-view")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["items-center", {
      block: props.labelPosition === 'top',
      flex: props.labelPosition === 'left',
    }]),
    style: _normalizeStyle({ height: setScrollHeight.value })
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(`text-size-30 ${setLabelAlign.value} scroll-form-checkbox-label`),
      style: _normalizeStyle({
        width: setLabelWidth.value,
        minWidth: setLabelWidth.value,
        height: setLabelHeight.value,
        color: props.labelColor,
      })
    }, _toDisplayString(props.label), 7),
    _createVNode(_component_taro_scroll_view, {
      enablePassive: "",
      enhanced: "",
      class: "flex items-center",
      refresherTwoLevelEnabled: true,
      refresherTwoLevelTriggered: true,
      "scroll-y": false,
      "scroll-x": true,
      showScrollbar: "",
      scrollWithAnimation: ""
    }, {
      default: _withCtx(() => [
        (props.data?.length)
          ? (_openBlock(), _createBlock(_component_nut_config_provider, {
              key: 0,
              "theme-vars": themeVars.value
            }, {
              default: _withCtx(() => [
                _createVNode(_component_nut_checkbox_group, {
                  modelValue: value.value,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((value).value = $event)),
                  direction: "horizontal",
                  class: "flex-important",
                  onChange: handleChange
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.data, (item) => {
                      return (_openBlock(), _createBlock(_component_nut_checkbox, {
                        onClick: ($event: any) => (handleClick(item[props.field.id])),
                        label: item[props.field.id],
                        key: item[props.field.id]
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(item[props.field.name]), 1)
                        ]),
                        _: 2
                      }, 1032, ["onClick", "label"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }, 8, ["theme-vars"]))
          : (_openBlock(), _createBlock(_component_nut_skeleton, {
              key: 1,
              width: "300px",
              animated: ""
            }))
      ]),
      _: 1
    })
  ], 6))
}
}

})